
  import { defineComponent } from 'vue';
  import { Modal } from '@/ui/components/Modal';
  import { Button } from '@/ui/components/Button';
  import { SESSION_LIMITATION_MODAL_WIDTH } from '@/ui/components/modals/constants';
  import { resetLogin } from '@/ui/auth/auth';

  export default defineComponent({
    components: {
      Modal,
      Button,
    },
    setup() {
      const logoutAndRedirect = () => {
        resetLogin();

        window.location.href = '/login';
      };

      return {
        logoutAndRedirect,
        SESSION_LIMITATION_MODAL_WIDTH,
      };
    },
  });
